import React, { useEffect, useState } from "react";
import Card from "@mui/material/Card";
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import Table from "examples/Tables/Table";
import SoftAvatar from "components/SoftAvatar";
import userImage from "assets/images/illustrations/user.png";
import SoftButton from "components/SoftButton";
import { ApiResponse } from "model/apiResponseModel";
import api from "api/api";
import { useLocation, useNavigate } from "react-router-dom";
import SoftBadge from "components/SoftBadge";
import ProjectFilter from "./components/ProjectFilter";
import { convertSecondsToHoursLive } from "helpers/logMessages";
import { Link } from "react-router-dom";

export default function Verified() {
  const [columns, setColumns] = useState([]);
  const [rows, setRows] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const limit = 10;
  const navigate = useNavigate();
  const [status, setStatus] = useState("Pending");

  const fetchProjects = async (page = 1) => {
    try {
      setIsLoading(true);
      let postData = {
        limit,
        page,
      };

      if (status !== "All") {
        if (status === "Pending") {
          postData.isAdminVerified = false;
          postData.verification_status = "pending";
        } else {
          postData.isAdminVerified = true;
          postData.verification_status = status.toLowerCase();
        }
      }

      const response = await api.getVerificationsList(postData);
      console.log(response);
      const apiResponse = new ApiResponse(response.status, response.message);

      if (apiResponse.status === 1) {
        setColumns([
          { name: "project", align: "left" },
          { name: "design", align: "center" },
          { name: "artist", align: "center" },
          { name: "brand", align: "center" },
          { name: "logged Time", align: "center" },
          { name: "created", align: "center" },
          { name: "status", align: "center" },
          { name: "verification status", align: "center" },
        ]);

        setRows(
          response.data.projects.map((item) => ({
            linkPath: `/project-detail?projectId=${item._id}`,
            project: (
              <SoftBox display="flex" alignItems="center" px={1} pb={0.5}>
                <SoftAvatar
                  src={item.image[0] || userImage}
                  alt={item.name}
                  size="sm"
                  variant="rounded"
                />
                <SoftBox display="flex" flexDirection="column" ml={2}>
                  <SoftTypography variant="button" fontWeight="medium">
                    {item.name}
                  </SoftTypography>
                  <SoftTypography variant="caption" color="secondary">
                    {item.email}
                  </SoftTypography>
                </SoftBox>
              </SoftBox>
            ),
            design: (
              <SoftTypography 
                variant="caption" 
                color="secondary" 
                fontWeight="medium"
                sx={{ 
                  display: 'flex',
                  alignItems: 'center',
                  height: '100%',
                  minHeight: '40px'
                }}
              >
                {item.design}
              </SoftTypography>
            ),
            artist: (
              <SoftTypography variant="caption" color="secondary" fontWeight="medium">
                {item.artist}
              </SoftTypography>
            ),
            brand: (
              <SoftTypography variant="caption" color="secondary" fontWeight="medium">
                {item.brand}
              </SoftTypography>
            ),
            "logged Time": (
              <SoftTypography variant="caption" color="secondary" fontWeight="medium">
                {convertSecondsToHoursLive(item.totalDuration)}
              </SoftTypography>
            ),
            created: (
              <SoftTypography variant="caption" color="secondary" fontWeight="medium">
                {new Date(item.created_at * 1000).toLocaleDateString("en-US", {
                  month: "2-digit",
                  day: "2-digit",
                  year: "numeric",
                })}
              </SoftTypography>
            ),
            status: (
              <SoftBadge
                variant="gradient"
                badgeContent={
                  item.project_status === "not_started"
                    ? "Not Started"
                    : item.project_status === "ongoing"
                    ? "Ongoing"
                    : "Completed"
                }
                color={
                  item.project_status === "not_started"
                    ? "error"
                    : item.project_status === "ongoing"
                    ? "warning"
                    : "success"
                }
                size="xs"
              />
            ),
            "verification status": (
              <SoftBadge
                variant="gradient"
                badgeContent={
                  item.verification_status === "pending"
                    ? "Pending"
                    : item.verification_status === "approved"
                    ? "Approved"
                    : "Rejected"
                }
                color={
                  item.verification_status === "pending"
                    ? "warning"
                    : item.verification_status === "approved"
                    ? "success"
                    : "error"
                }
                size="xs"
              />
            ),
          }))
        );
        setTotalPages(response.data.totalPages);
      }
    } catch (error) {
      console.error("Error fetching projects:", error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    const loginData = JSON.parse(
      localStorage.getItem("loginData") || sessionStorage.getItem("loginData")
    );

    if (!loginData) {
      navigate("/authentication/sign-in");
    } else {
      fetchProjects(currentPage);
    }
  }, [currentPage, navigate, status]);

  const handlePageClick = (page) => {
    setCurrentPage(page);
    // console.log(page);
    fetchProjects(page);
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <SoftBox py={3}>
        <SoftBox mb={3}>
          <Card>
            <SoftBox display="flex" justifyContent="space-between" alignItems="center" p={3}>
              <SoftTypography variant="h6" width="20%">
                Verifications
              </SoftTypography>
              <ProjectFilter status={status} setStatus={setStatus} />
            </SoftBox>
            <SoftBox
              sx={{
                "& .MuiTableRow-root:not(:last-child)": {
                  "& td": {
                    borderBottom: ({ borders: { borderWidth, borderColor } }) =>
                      `${borderWidth[1]} solid ${borderColor}`,
                  },
                },
              }}
            >
              {isLoading ? (
                <SoftBox
                  display="flex"
                  height="500px"
                  justifyContent="center"
                  alignItems="center"
                  p={3}
                >
                  <SoftTypography variant="subtitle1" color="textSecondary">
                    Loading...
                  </SoftTypography>
                </SoftBox>
              ) : rows.length > 0 ? (
                <Table columns={columns} rows={rows} />
              ) : (
                <SoftBox display="flex" justifyContent="center" alignItems="center" p={3}>
                  <SoftTypography variant="subtitle1" color="textSecondary">
                    No Projects Found
                  </SoftTypography>
                </SoftBox>
              )}
            </SoftBox>
            <SoftBox display="flex" alignItems="center" justifyContent="center" py={2}>
              {/* Previous Button */}
              <SoftButton
                variant="outlined"
                color="primary"
                onClick={() => handlePageClick(currentPage - 1)}
                disabled={currentPage === 1}
                sx={{ mx: 1 }}
              >
                Previous
              </SoftButton>

              <SoftButton
                key={currentPage}
                variant="contained"
                color="primary"
                // onClick={() => handlePageClick(pageNumber)}
                sx={{ mx: 0.5 }}
              >
                {currentPage}
              </SoftButton>

              {/* Next Button */}
              <SoftButton
                variant="outlined"
                color="primary"
                onClick={() => handlePageClick(currentPage + 1)}
                disabled={currentPage === totalPages || totalPages === 0}
                sx={{ mx: 1 }}
              >
                Next
              </SoftButton>
            </SoftBox>
          </Card>
        </SoftBox>
      </SoftBox>
      <Footer />
    </DashboardLayout>
  );
}
